// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/SlackSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var SlackSquareOutlined = function SlackSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareOutlinedSvg
  }));
};

SlackSquareOutlined.displayName = 'SlackSquareOutlined';
export default React.forwardRef(SlackSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SlackSquareOutlined.js
// module id = 1827
// module chunks = 0